import React from 'react';
import { Dialog, DialogContent, Grid, Button, Typography, Box } from '@mui/material';
import CloseBtnImg from '../assets/images/icons/close_btn.svg'
import s from './Modal.module.css'

const Modal = (props) => {
  return (
    <Dialog data-testid="modal" maxWidth={'md'} open={props.open} onClose={props.onClose}>
      <DialogContent className={s.dialogContent}>
        <img src={CloseBtnImg} alt="Botão de fechar" className="img__btnclose--container" onClick={props.onClose} />
        <form onSubmit={(e) => {
          e.preventDefault();
          if (props.action) {
            const a = new FormData(e.target);
            props.action(Object.fromEntries(a.entries()));
          }
        }}>
          <Typography className={s.typographyModalName}>
            {props.modalName.toUpperCase()}
          </Typography>
          <Box>
            {props.children}
          </Box>
          {
            props.hideButtons ? null :
              <Grid item>
                <Grid container justifyContent='flex-end' direction='row' spacing={2}>
                  {props.onClose &&
                    <Grid item>
                      <Button data-testid="buttonClose" className={s.buttonClose} onClick={props.onClose} variant="outlined" color="primary">
                        {props.closeName || "VOLTAR"}
                      </Button>
                    </Grid>
                  }
                  {props.action &&
                    <Grid item>
                      <Button data-testid="buttonAction" className={s.buttonAction} type='submit' variant="contained" disabled={props.isUploading}>
                        {props.actionName || "SALVAR"}
                      </Button>
                    </Grid>
                  }
                </Grid>
              </Grid>
          }
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
